/* request interceptors */

// 针对webim自定义侧边栏作跨域请求处理
export function corsSidebarInterceptor(config) {
    try {
        let url = config.url;
        const CORS_DOMAIN_REGULAR = [
            '/receptionConf/sidebar/template/delete',
            '/receptionConf/sidebar/template/pageList',
            '/receptionConf/announcement/delete',
            '/receptionConf/interactNav/list',
            '/receptionConf/interactNav/delete'
        ]

        // 考虑url是带域名的情况
        if(url.match('gateway.qidian.qq.com')){
            url = url.replace(/http(s)?:\/\/(test)?gateway.qidian.qq.com/, '')
        }

        if (CORS_DOMAIN_REGULAR.includes(url)) {
            config.withCredentials = true;
            const hostName = location.hostname;
            if (hostName === 'oaadmin.qidian.qq.com') {
                config.url = `//testgateway.qidian.qq.com${url}`
            }
            else if (hostName === 'admin.qidian.qq.com') {
                config.url = `//gateway.qidian.qq.com${url}`
            }
        }
        return config;
    } catch (error) {
        console.log('corsSidebarInterceptor', error);
        return config;
    }
}

// 针对热词分析跨域请求设置
export function corsDeptInterceptor(config) {

    const URL = config.url;
    const CORS_DOMAIN_REGULAR = /\/\/(test)?gateway\.qidian\.qq\.com\/v\w\/org\/orgTree/;

    if (CORS_DOMAIN_REGULAR.test(URL) && /\/cl\/hotwordAnalytics\/ov/.test(window.location.href)) {
        config.withCredentials = true;
        delete config.data.index;
        if (config.data.count === -1 && config.data.id === undefined) {
            config.data.depId = 0;
        }
        else if (config.data.count === -1 && config.data.id !== undefined) {
            config.data.depId = config.data.id;
        }
        delete config.data.count;
    }

    return config;
}